module.exports = __webpack_public_path__ + "img/style.0b628269.png";